import { useState } from "react";

export const useAddAssignmentTemplateModal = ({ getAllAssignmentTemplates }) => {
  const [templates, setTemplates] = useState([]);

  const getAssignmentTemplates = async () => {
    const result = await getAllAssignmentTemplates();
    setTemplates(result);
  };

  const findTemplate = (name) =>
    templates.find(({ name: templateName }) => templateName === name);

  return {
    templates: templates.map(({ name, id }) => ({
      key: id,
      label: name,
      value: name,
    })),
    findTemplate,
    getAssignmentTemplates,
  };
};
